import { Config } from "../core/config/config.js";
import { ResourcePlanningSchedulerEventViewModel } from "./resourcePlanningScheduler.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { SkillCategory } from "../generalSettings/skills/skillsInterfaces.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
interface AssignmentInfoState {
    showDialog: boolean;
}

export class AssignmentInfo extends React.Component<AssignmnetInfoProps, AssignmentInfoState> {
    // @ts-ignore
    private _wrapperStyle: React.CSSProperties = { borderBottom: "1px solid #eaeaea" };
    // @ts-ignore
    private _labelStyle: React.CSSProperties = { fontWeight: "bold", paddingTop: "5px", paddingRight: "10px" };
    // @ts-ignore
    private _valueStyle: React.CSSProperties = { paddingTop: "5px" };
    private _dialogOptions: DialogProps = {
        actions: [{
            action: () => {
                this.setState({ showDialog: false });
            },
            label: Config.translations.ok,
            primary: true
        }],
        title: "Assignment Infos",
        afterClose: () => {
            this.setState({ showDialog: false });
        }
    }


    constructor(props: AssignmnetInfoProps) {
        super(props);
        this._dialogOptions.title = props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.AssignmentInfo"];

        this.state = {
            showDialog: false
        };
    }

    private _formatField = (label: string, value: any) => {
        return <tr style={this._wrapperStyle}><td style={this._labelStyle}>{label}:</td><td style={this._valueStyle}>{value}</td></tr>
    }

    private _openDialog = () => {
        this.setState({ showDialog: true });
    }


    render() {
        return (
            this.props.assignment ?
                <div style={{ marginBottom: "10px" }}>
                    <label style={{ marginRight: "10px" }}>{this.props.translations["Einsatz.Einsatz"]}:</label>
                    <a onClick={this._openDialog}>{this.props.assignment.Projnr} / {this.props.assignment.Pindex} - {this.props.assignment.Title}</a>
                    <a onClick={this._openDialog} style={{ marginLeft: "10px", fontSize: "10px" }}>({this.props.translations["Standard.Mehr"]})</a>
                    {
                        this.state.showDialog ?
                            <Dialog open={true} {...this._dialogOptions}>
                                <div style={{ margin: "5px" }}>
                                    <table>
                                        <tbody>
                                            {this._formatField(this.props.translations["Projekt.Projekt"], this.props.assignment.Projnr)}
                                            {this._formatField(this.props.translations["Field.Einsatz.pindex"], this.props.assignment.Pindex)}
                                            {this._formatField(this.props.translations["Ressource.Ressource"], this.props.assignment.ResourceName)}
                                            {this._formatField(this.props.translations["Adresse.Adresse"], this.props.assignment.AdrNr)}
                                            {this._formatField(this.props.translations["Field.Adresse.adrname"], this.props.assignment.AdrName)}
                                            {this._formatField(this.props.translations["Field.Projekt.startist"], this.props.assignment.Start)}
                                            {this._formatField(this.props.translations["Field.Projekt.endeist"], this.props.assignment.End)}
                                            {this._formatField(this.props.translations["Field.Einsatz.soll"], this.props.assignment.TargetHours > 0 ? this.props.assignment.TargetHours : 0)}
                                            {this._formatField(this.props.translations["Field.Einsatz.continuationjourney"], this.props.assignment.ContinuationJourney ? '✓' : '✗')}
                                            {this._formatField(this.props.translations["Field.Einsatz.Bemerkung"], this.props.assignment.Title)}
                                        </tbody>
                                    </table>
                                </div>
                            </Dialog>
                            : null
                    }
                </div>
                : null
        );
    }
}

export enum JourneyOutStart {
    Previous = 0, Home = 1
}

export enum JourneyBackEnd {
    Next = 0, Home = 1
}

export enum ContinuousPeriodUnit {
    Hours = 0, Days = 1
}


export interface SuitableResourceSearchProps {
    onActivated?: (data: SuitableResourceSearchSettings) => void;
    onDeactivated?: (data: SuitableResourceSearchSettings) => void;
    onApply?: (data: SuitableResourceSearchSettings) => void;
    settings: SuitableResourceSearchSettings;
    minStartDate: Date;
    maxEndDate: Date;
    translations: StringKeyDictionary<string>;
    sourceEvent: ResourcePlanningSchedulerEventViewModel;
}

export interface SuitableResourceSearchSettings {
    startDate: Date;
    endDate: Date;
    pIndex: number;
    projNr: string;
    assignmentToDistributeId: string;
    startAddress: string;
    isActive: boolean;
    continuousPeriod: number;
    continuousPeriodUnit: ContinuousPeriodUnit;
    availabilityPercentage: number;
    journeyOut: JourneyOutStart;
    journeyBack: JourneyBackEnd;
    skills: Array<SkillCategory>;
    useSkills: boolean;
    useGeomap: boolean;
    useContinuationJourney: boolean;
    considerFlags: boolean;
    considerGroup: boolean;
    considerMainGroup: boolean;
    considerSkills: boolean;
}

export interface AssignmnetInfoProps {
    assignment: ResourcePlanningSchedulerEventViewModel;
    translations: StringKeyDictionary<string>;
}